import Services from '../../services'

const state = {
  orders: [],
  currentOrder: {},
  paymentInfo: {},
  isShowBuyModal: false,
  buyModalData: null,
};

// getters
const getters = {
  orders: (state, getters, root) => {
    return state.orders;
  },
  currentOrder: (state, getters, root) => {
    return state.currentOrder
  },
  paymentInfo: (state, getters, root) => {
    return state.paymentInfo
  },
  isShowBuyModal: state => state.isShowBuyModal,
  buyModalData: state => state.buyModalData,
};

// actions
const actions = {
  async fetchOrders({ commit, state, dispatch }) {
    const data = await Services.Orders.fetchOrders();
    let orders = data.default.map(e => { e.small = true; return e; })
    commit('updateOrders', orders);
  },
  async createOrder({commit, state, dispatch}, order) {
    const data = await Services.Orders.createOrder(order);
    commit('buyOrder', data);
  },
  async getPaymentInfo({commit, state, dispatch}) {
    console.log("getPaymentInfo")
    const data = await Services.Orders.paymentInfo(state.currentOrder.orderId);
    // let pinfo = data
    commit('setPaymentInfo', data);
  },
};

// mutations
const mutations = {
  updateOrders(state, data) {
    state.orders = [].concat(data);
  },
  buyOrder(state, data) {
    state.currentOrder = data;
  },
  setPaymentInfo(state, data) {
    state.paymentInfo = data;
  },
  setShowBuyModal(state, status) {
    state.isShowBuyModal = status;
  },
  setBuyModalData(state, data) {
    state.buyModalData = data;
  },
  setWalletId(state, walletId) {
    state.buyModalData.walletId = walletId
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js